import React from "react";
import {useTheme} from "@material-ui/core/styles";
import {Box, Container, Grid} from "@material-ui/core";
import {Navigation} from "../../Components";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import AppointmentSummary from "../AppointmentSummary";

const BookAgain: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Container maxWidth="md">
            <Box marginTop={isMobile ? "30px" : "100px"} marginBottom="75px">
                <Grid container>
                    {!isMobile &&
                    <Grid item xs={3}>
                        <Navigation/>
                    </Grid>
                    }
                    <Grid item md={9} xs={12}>
                        <Container>
                            <AppointmentSummary bookAgain />
                        </Container>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};
export default BookAgain;
